"use client";

import { type PropsWithChildren, useEffect } from "react";
import type { LangParams } from "../layout";
import { updateCartId } from "./actions/update/cartId";

type Props = PropsWithChildren & LangParams;

export function LegacyCartConverter(props: Props) {
	useEffect(() => {
		async function convertCart() {
			const cartId = localStorage.getItem("cartId");

			if (cartId) {
				await updateCartId({ cartId, lang: props.lang });
				localStorage.removeItem("cartId");

				console.info("Converted cart to cookie");
			}
		}

		convertCart().catch((err) => {
			console.error("Failed to convert cart to cookie", err);
		});
	}, [props.lang]);

	return props.children;
}
